<template>
    <div>
        <FormControl label="Options">
            <div class="space-y-1">
                <template
                    v-for="(option, index) in localOptions"
                    :key="index"
                >
                    <div class="flex items-center gap-1">
                        <TextInput
                            :name="`${RequestBodyKeyEnum.App_UpdateService_CustomFields_Settings}[${CustomFieldTypeEnum.MultipleCheckbox}][${CustomFieldSettingsKeysEnum.MultipleCheckbox_Options}][]`"
                            :value="option"
                            class="w-full"
                        />
                        <Button
                            @click="handleRemoveOption(index)"
                            iconName="trash"
                            color="light"
                            type="button"
                        ></Button>
                    </div>
                </template>
            </div>
            <div class="flex justify-end mt-2">
                <Button
                    @click="handleAddNewOption()"
                    iconName="plus"
                    color="light"
                    type="button"
                >
                    Add option
                </Button>
            </div>
        </FormControl>
    </div>
</template>

<script setup lang="ts">
    import { ref, type PropType } from 'vue'
    import CustomField from '@/App/CustomField/Entity/CustomField'
    import {
        CustomFieldTypeEnum,
        CustomFieldSettingsKeysEnum,
        type CustomFieldSettingsMultipleCheckboxType,
    } from '@/Shared/AutoGenerated/Main'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import Button from '@/Shared/Component/Button.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        customField: {
            type: Object as PropType<CustomField | null>,
            default: null,
        },
    })

    const localSettings: CustomFieldSettingsMultipleCheckboxType | null =
        props.customField?.settings
    const localOptions = ref<string[]>(
        localSettings?.data?.multipleCheckboxOptions ?? [],
    )

    const handleAddNewOption = () => {
        localOptions.value.push('')
    }

    const handleRemoveOption = (index: number) => {
        localOptions.value = localOptions.value.filter(
            (option, optionIndex) => {
                return index !== optionIndex
            },
        )
    }
</script>
